import { useCallback } from "react";

import type { PlanCustomMailSettingInput, PlanInput } from "@/lib/gql/__generated__/graphql";

import { useCustomMutation } from "@/hooks/use-graphql-client";

import { START_GUIDE_QUERY } from "@/components/features/_shared/repository/start-guide/query/schema";
import { PlanList_PlanListPage_Query } from "@/components/features/items/list/plan/model/repository/query/fetch-plan-list/query";

import { StandardPlanCreateMutation } from "./mutation";

export const useCreatePlanMutation = () => {
	const { mutationFunc } = useCustomMutation(StandardPlanCreateMutation);

	const onCreatePlan = useCallback(
		async (input: PlanInput, planCustomMailSettingInput: PlanCustomMailSettingInput) =>
			await mutationFunc({
				variables: {
					input,
					planCustomMailSettingInput,
				},
				refetchQueries: [
					{
						query: PlanList_PlanListPage_Query,
						variables: {
							hotelID: input.hotelID,
						},
					},
					{
						query: START_GUIDE_QUERY,
						variables: { hotelID: input.hotelID },
					},
				],
			}),
		[mutationFunc],
	);

	return { onCreatePlan };
};
